// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class Toggler extends WebComponent {
	didMount() {
    const {
      toggleClass,
      target,
      esp,
    } = this.props;

    this.on('click', () => {
        this.element.classList.toggle(toggleClass);

        const targetElement = document.querySelector(target);
        targetElement.classList.toggle(toggleClass);

		const espElement = document.querySelector('.' + esp) || false;
		if(espElement) {
			espElement.classList.toggle('visible');
		} else {
			document.querySelector('.esp').classList.remove('visible');
		}

		if(espElement.classList.contains('visible')) {
			document.body.style.overflowY = "hidden";
		} else {
			document.body.style.overflowY = null;
			// document.body.style.overflowY = "";
		}

		const openToggles = document.querySelectorAll('.' + toggleClass);

        openToggles.forEach((toggle) => {
          if ((toggle != this.element) && (toggle != targetElement)) {
			toggle.classList.remove(toggleClass);
          }
        });
    });
	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Toggler.js